import { LOCAL_STORAGE_KEY } from 'constants/localStorage';
import * as ls from 'local-storage';

import { HalloweenBanner } from './banners/HalloweenBanner';
import { NewYearBanner } from './banners/NewYearBanner';
import { SimpleBanner } from './banners/SimpleBanner';
import { StripeOfferBanner } from './banners/StripeOfferBanner';
import { Mode, NormalizeMode } from './types';

export const PAYMENT_API_ENDPOINT = import.meta.env.VITE_PAYMENT_API_ENDPOINT;


export const defaultMode: NormalizeMode = {
  relativeDate: null,
  dateStart: null,
  dateEnd: null,
  upperBlock: null,
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$7.49/month',
      chevronText: 'Save 42%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: false,
    showTimer: false,
    titleText: null,
    bannerComponent: SimpleBanner
  }
};

const OCTOBER_INDEX = 9;
const NOVEMBER_INDEX = 10;
const halloweenMode: Mode = {
  relativeDate: () => new Date(Date.now()),
  dateStart: () => new Date(Date.UTC(2024, OCTOBER_INDEX, 29, 7)),
  dateEnd: () => new Date(Date.UTC(2024, NOVEMBER_INDEX, 2, 7)),
  upperBlock: {
    title: 'Halloween Sale',
    subText: 'Save 61% with a yearly subscription.'
  },
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$59.99/year ($4.99/month)',
      chevronText: 'Save 61%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year-halloween`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: false,
    showTimer: false,
    titleText: null,
    bannerComponent: HalloweenBanner
  }
};

const DECEMBER_INDEX = 11;
const JANUARY_INDEX = 0;
const newYearMode: Mode = {
  relativeDate: () => new Date(Date.now()),
  dateStart: () => new Date(Date.UTC(2024, DECEMBER_INDEX, 21, 0, 0, 0)),
  dateEnd: () => new Date(Date.UTC(2025, JANUARY_INDEX, 10, 8, 0, 0)),
  upperBlock: null,
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$69.99/year ($5.83/month)',
      chevronText: 'Save 55%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year-newyear`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: true,
    showTimer: true,
    titleText: null,
    bannerComponent: NewYearBanner
  }
};


const stripeOfferMode: Mode = {
  relativeDate: () => new Date(Date.now()),
  dateStart: () => new Date(Date.UTC(2024, DECEMBER_INDEX, 21, 0, 0, 0)),
  dateEnd: () => new Date(Date.UTC(2026, JANUARY_INDEX, 2, 8, 0, 0)),
  upperBlock: null,
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$89.99 ($7.49/month)',
      chevronText: 'Save 42%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year`
    },
    upgradeButton: {
      title: 'Upgrade for a year',
      subText: '$59.99 ($6/month)',
      payUrl: '',
      chevronText: 'Save 54%'
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    },
    trialTestButton: {
      title: 'Test month trial',
      subText: '$0.02/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: true,
    showTimer: false,
    titleText: null,
    bannerComponent: StripeOfferBanner
  }
};

// TODO: Разобраться что такое personalFirstHourMode почему она не используется и выпилить если не нужна

const personalFirstHourMode: Mode | null = {
  // eslint-disable-next-line no-constant-binary-expression
  relativeDate: () => new Date(ls.get<string>(LOCAL_STORAGE_KEY.EMAIL_VERIFICATION_DATE)) || null,
  dateStart: relativeDate => new Date(relativeDate),
  dateEnd: relativeDate => new Date(relativeDate.getTime() + 1 * 60 * 60 * 1000),
  upperBlock: {
    title: 'Special Offer',
    subText: 'Limited time offer just for you!'
  },
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$69.99/year',
      chevronText: 'Save 70%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year-special`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: true,
    showTimer: true,
    titleText: 'Get a special discount for the next 1 hour only!',
    bannerComponent: SimpleBanner
  }
};

// TODO: Разобраться что такое personalFirstHourMode почему она не используется и выпилить если не нужна

const personalFirstWeekMode: Mode | null = {
  // eslint-disable-next-line no-constant-binary-expression
  relativeDate: () => new Date(ls.get<string>(LOCAL_STORAGE_KEY.EMAIL_VERIFICATION_DATE)) || null,
  dateStart: relativeDate => new Date(relativeDate.getTime() + 167 * 60 * 60 * 1000),
  dateEnd: relativeDate => new Date(relativeDate.getTime() + 215 * 60 * 60 * 1000),
  upperBlock: {
    title: 'Special Offer',
    subText: 'Limited time offer just for you!'
  },
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$69.99/year',
      chevronText: 'Save 70%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year-special`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: true,
    showTimer: true,
    titleText: 'Second Chance: Don`t miss your last opportunity to get the discount!',
    bannerComponent: SimpleBanner
  }
};

export const modes: Mode[] = [stripeOfferMode];
